import React from "react";

/**
 * Novocreste logo mark — recreated as a crisp SVG.
 * Blue→teal arch (like the source logo) with a gold droplet at the apex.
 */
export default function Logo({ className = "", size = 40 }) {
  const id = React.useId();
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 100 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Novocreste"
    >
      <defs>
        <linearGradient id={`arch-${id}`} x1="12" y1="70" x2="88" y2="70" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#3E7CB1" />
          <stop offset="0.55" stopColor="#3E93A8" />
          <stop offset="1" stopColor="#45AE8B" />
        </linearGradient>
        <linearGradient id={`drop-${id}`} x1="50" y1="4" x2="50" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F0C46A" />
          <stop offset="1" stopColor="#D29A2E" />
        </linearGradient>
      </defs>
      {/* Arch */}
      <path
        d="M16 74 A34 34 0 0 1 84 74"
        stroke={`url(#arch-${id})`}
        strokeWidth="9.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Gold droplet at apex */}
      <path
        d="M50 5 C54.5 12 57 15.5 57 18.8 C57 22.6 53.9 25.5 50 25.5 C46.1 25.5 43 22.6 43 18.8 C43 15.5 45.5 12 50 5 Z"
        fill={`url(#drop-${id})`}
      />
    </svg>
  );
}
